import {cn, cva} from 'platform/shared';

import {ComponentPropsWithoutRef, createElement} from 'react';

const toolbarUploadingSpinnerVariants = cva(
  'absolute top-1/2 right-2 flex -translate-y-1/2 items-center'
);

export function ToolbarUploadingSpinner(props: ComponentPropsWithoutRef<'span'>) {
  return createElement('span', {
    ...props,
    className: cn(toolbarUploadingSpinnerVariants(), props.className),
  });
}
